import { useAuth } from '../../../../app/AuthorizationProvider';
// eslint-disable-next-line import-x/no-cycle
import { INavItem } from '../Navigation';

export const addMenuPathsWithPermissions = (menu: INavItem[]) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { userHasPermissions } = useAuth();
  const pathsGranted = menu.map((menuItem) => {
    // if no submenu at all
    if (!menuItem.submenu) {
      return userHasPermissions(menuItem.requiredPermissions) ? menuItem : null;
    }

    const availableSubmenuItems = menuItem.submenu.filter((submenu) => userHasPermissions(submenu.requiredPermissions));
    // if none of the submenu permissions are met
    if (!availableSubmenuItems.length) {
      return null;
    }

    return {
      ...menuItem,
      submenu: availableSubmenuItems,
    };
  });

  const nonNullPathsGranted = pathsGranted.filter((path) => path) as INavItem[];

  return nonNullPathsGranted;
};
